import { type ReactNode } from 'react';

import { Stack } from '@cast/design-system';

export const INVENTORY_WORKLOADS_SETTINGS_SLOT_ID =
  'portal-slot-inventory-workloads-settings';

export type InventoryWorkloadsFiltersArgs = {
  categoryToggle: ReactNode;
  dateControl: ReactNode;
};

export const InventoryWorkloadsFilters = ({
  categoryToggle,
  dateControl,
}: InventoryWorkloadsFiltersArgs) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      width="100%"
    >
      <Stack direction="row" alignItems="center" gap={8}>
        {categoryToggle}
        <div id={INVENTORY_WORKLOADS_SETTINGS_SLOT_ID} />
      </Stack>

      {dateControl}
    </Stack>
  );
};
